import React from 'react'
import PrevNextControls from '../../prev-next-controls/prev-next-controls'
import withPresentation from '../with-presentation'

const SlideControlsContainer = ({
  presentation,
  presentationState,
  ...props
}) => {
  return (
    <PrevNextControls
      position={presentationState.slidePosition}
      onPrevSlide={presentationState.prevSlide}
      onNextSlide={presentationState.nextSlide}
      {...props}
    />
  )
}

export default withPresentation(SlideControlsContainer)
